<script lang="ts" setup>
import ModalOverlay from './ModalOverlay.vue';

defineProps<{
    title: string;
    inner?: boolean;
    center?: boolean;
}>();
const emit = defineEmits<{
    clickedOutSide: [];
}>();
const modalRef = ref<HTMLDivElement>();
const slots = useSlots();

onClickOutside(modalRef, () => emit('clickedOutSide'));
</script>

<template>
    <div ref="modalRef" class="support-flow" :class="{ inner, center }">
        <div class="support-flow-content-wrapper">
            <div class="support-flow-content">
                <div class="support-flow-header">
                    <slot name="back-action">
                        <div />
                    </slot>
                    <mr-typography
                        class="support-header-title"
                        weight="700"
                        color="var(--gray-900)"
                    >
                        {{ title }}
                    </mr-typography>
                    <slot name="forward-action">
                        <div />
                    </slot>
                </div>
                <slot>
                    <mr-typography> موردی برای نمایش موجود نیست.</mr-typography>
                </slot>
            </div>
            <div class="session-footer">
                <slot name="footer" />
            </div>
            <ModalOverlay v-if="slots.overlay">
                <slot name="overlay" />
            </ModalOverlay>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.support-flow {
    contain: layout;
    position: absolute;
    height: 100%;
    width: 100%;
    @include desktop-only {
        width: 360px;
        height: 70vh;
        &:not(.inner) {
            right: 56px;
            bottom: 125px;
        }
        &.center {
            right: calc(50vw - (360px / 2));
        }
    }
    @include scroll-fantasy;
    .support-flow-content-wrapper {
        overflow-x: hidden;
        height: 100svh;
        @include desktop-only {
            border-radius: 16px;
            background-color: white;
            height: 100%;
        }
        z-index: 9999999;
        .support-flow-content {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 12px;
            height: 100%;
            .support-flow-header {
                position: sticky;
                top: 0;
                width: 100%;
                display: grid;
                grid-template-columns: 0.1fr 1fr 0.1fr;
                padding-block: 8px;
                background-color: white;
                z-index: 99999;
                :deep(.mr-button.primary.filled) {
                    background: usePalette($p-cool-gray, $p-200) !important;
                }
                .support-header-title {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }

        .session-footer {
            position: fixed;
            bottom: 0;
            right: 0;
            left: 0;
            margin-top: auto;
            @include desktop-only {
                border-radius: 0 0 12px 12px;
            }
        }
    }
}
</style>
